export default __webpack_public_path__ + "static/media/uberLogoWhite.4e56b98a.svg";